import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import Img from 'gatsby-image';
import './NewsCard.scss';

import { H3, TextSmall } from 'components/typography';
import { TopTitle } from 'components/SectionTitle';

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
`;

const ImageContainer = styled.div`
  margin-bottom: 2.4rem;
  overflow: hidden;

  ${({ theme }) => theme.breakpoints.maxMobile} {
    margin-bottom: 1.6rem;
  }
`;

const Image = styled(Img)`
  width: 100%;
  transition: 400ms transform;
  height: 28rem;

  ${CardContainer}:hover & {
    transform: scale(1.05);
  }
`;

const SubtitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.6rem;
`;

const Subtitle = styled(TopTitle)`
  font-weight: 400;
  margin-bottom: 0;
`;

const Date = styled(Subtitle)`
  color: ${({ theme }) => theme.palette.navyGrayLighten5};
`;

const CardTitle = styled(H3)`
  margin-bottom: 0.8rem;
  transition: all 300ms;
  font-size: 1.6rem;

  ${CardContainer}:hover & {
    color: ${({ theme }) => theme.palette.blueBase};
  }
`;

const Description = styled(TextSmall)`
  transition: all 300ms;
  font-size: 1.4rem;

  ${CardContainer}:hover & {
    color: ${({ theme }) => theme.palette.navyGrayDarken15};
  }
`;

const BottomText = styled.span`
  position: relative;
  display: inline-block;
  text-decoration: none;
  font-weight: 400;
  z-index: 2;
  font-size: 1.4rem;
  line-height: 2.4rem;
  color: ${({ theme }) => theme.palette.blackLighten5};

  margin-top: 2.4rem;
  padding-bottom: 0.8rem;

  ${({ theme }) => theme.breakpoints.maxMobile} {
    display: none;
  }

  &::after {
    content: '';
    border-bottom: 1px solid ${({ theme }) => theme.palette.grayLighten5};
    left: 0;
    position: absolute;
    width: 100%;
    bottom: 0;
    pointer-events: none;
  }

  ${CardContainer}:hover & {
    hr {
      width: 100%;
    }
  }

  hr {
    position: absolute;
    bottom: 0;
    width: 0;
    height: 1px;
    border: 0;
    background: ${({ theme }) => theme.palette.blackLighten5};
    z-index: 1;
    transition: all 0.2s ease-out;
    pointer-events: none;
  }
`;

const NewsCard = ({ image, altText, date, tag, title, description, link, index }) => (
  <div data-sal="slide-up" data-sal-easing="ease" data-sal-delay={(index + 1) * 100}>
    <Link to={`/blog/${link}`} className="news-card">
      <CardContainer>
        {/* @TODO check if this approach with two divs for spacing between main section and link is ok */}
        <div>
          <ImageContainer>
            <Image fluid={image} alt={altText} />
          </ImageContainer>
          <SubtitleWrapper>
            <Subtitle>{tag}</Subtitle>
            <Date>{date}</Date>
          </SubtitleWrapper>
          <CardTitle>{title}</CardTitle>
          <Description>{description}</Description>
        </div>
        <div>
          <BottomText>
            Read more
            <hr />
          </BottomText>
        </div>
      </CardContainer>
    </Link>
  </div>
);

export default NewsCard;
